module.exports = __webpack_public_path__ + "media/images/certificates/certificat-03-52bea1a1d779b7d5f9ef74d5289db925.webp";